import { Component } from '@angular/core';

@Component({
  selector: 'app-send-direct-message',
  templateUrl: './send-direct-message.component.html',
  styleUrls: ['./send-direct-message.component.scss']
})
export class SendDirectMessageComponent {

}
